import { EventEmitter, Inject, Injectable, Output, PLATFORM_ID, Renderer2 } from '@angular/core';
import { BeatsService } from '../beats-service/beats.service';
import { Meta, Title } from '@angular/platform-browser';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import COUNTRIES_LIST  from "../../../assets/countries/countries_en.json";
import AGE_LIST  from "../../../assets/data/age-list.json";
import URL_PARAMETERS  from "../../../assets/data/url-parameters.json";
import FILTER_JSON  from "../../../assets/data/filter-list.json";
import { CountriesListModel } from 'src/app/models/countries-list.model';
import { FilterListModel, FilterSubsListObj } from 'src/app/models/filter-list-model';
import { SearchFilterModel } from 'src/app/models/search-list.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserDetails } from 'src/app/models/user-details.model';
import { StoreObj } from 'src/app/models/beat-list-model';
import { BillingListModel } from 'src/app/models/billing-address.model';
import { BrowserStorageService } from '../browser-storage/browser-storage.service';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  selectedSearchInputValue: string = '';
  private readonly defaultSearchType: SearchFilterModel = {
    label: 'General',
    value: 'general',
    apiKeys: [],
  };
  private _selectedSearchType: SearchFilterModel = this.defaultSearchType;
  searchFilterType: Array<SearchFilterModel> = [];
  searchPlaceholderText: string = 'beats';
  isMobileDisableClick: boolean = false;
  modelRef: MatDialogRef<any>;
  bottomRef: MatBottomSheetRef<any>;
  modelRefSecond: MatDialogRef<any>;
  isShowTwoPopupSameTime: boolean = false;
  menuBaseUrl: string = '../../assets/data/sidebar-menu.json';
  bottomRefSecond: MatBottomSheetRef<any>;
  filterOptionList: Array<FilterListModel> = [];
  urlKeysList: Array<{type: string, key: string}> = [];
  isCallingPagination: BehaviorSubject<boolean> =  new BehaviorSubject(false);
  cartDataList: BehaviorSubject<any> = new BehaviorSubject('');
  billingAddressEvent: BehaviorSubject<any> = new BehaviorSubject([]);
  playListSubscription: BehaviorSubject<[]> = new BehaviorSubject([]);
  topPicksPlaylist: any = {};
  genreListSubscription: BehaviorSubject<[]> = new BehaviorSubject([]);
  beatView: BehaviorSubject<string> = new BehaviorSubject('list');
  isShowMusicConfirmationPopup: BehaviorSubject<string> = new BehaviorSubject('');
  isOpenAuthPopup: BehaviorSubject<string> = new BehaviorSubject('');
  updatePlayPauseStatus: BehaviorSubject<any> = new BehaviorSubject('');
  isShowBannerPromo: BehaviorSubject<any> = new BehaviorSubject('');
  isUserApproved: BehaviorSubject<any> = new BehaviorSubject(false);
  isMusicPlaying$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isSpeechListening$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Output() selectAddressPopupEvent: EventEmitter<any> = new EventEmitter();
  openSubsModel: BehaviorSubject<any> = new BehaviorSubject('');
  /** Ask the layout (which owns the popup) to open the Diwali Pro Annual popup, e.g. from the sale banner's offer pill */
  openDiwaliProPopup$: Subject<void> = new Subject<void>();
  platformSaleData: BehaviorSubject<any> = new BehaviorSubject('');
  /** Enrollment open for the active platform sale (set in saleDataUpdate) */
  enrollmentActive: boolean = false;
  /** Active platform sale is running, between start_at and end_at (set in saleDataUpdate) */
  saleActive: boolean = false;
  /** Producer has beats enrolled in the active sale (set by bpm-festival after loading beats) */
  isProducerSaleEnrolled: boolean = false;
  currentCreditBalanceChanges: BehaviorSubject<any> = new BehaviorSubject(0);
  suppressCartDropdown: boolean = false;
  sortFilter: BehaviorSubject<any> = new BehaviorSubject({
    name:"One Scroll Algo",
    id:"3",
    key:"one_scroll_algo"
  });
  textArray: Array<any> = [{
    key: "hiphop",
    value: "Hip-hop"
  },{
    key: "pop",
    value: "Pop"
  }];
  typeOfList: string = "hiphop";
  isNewBeatLogoEnable: boolean = true;
  isSetFilterPositionFixed: boolean = false;

  private readonly generalSearchPlaceholders: string[] = [
    'beat title',
    'tag',
    'mood',
    'genre',
    'handle',
    'studio',
  ];
  private searchPlaceholderIndex = 0;
  private searchPlaceholderTimers: number[] = [];

  get selectedSearchType(): SearchFilterModel {
    return this._selectedSearchType;
  }

  set selectedSearchType(value: SearchFilterModel) {
    this._selectedSearchType = value || this.defaultSearchType;
    this.refreshSearchPlaceholder();
  }

  constructor(private beatService: BeatsService,
    private matDialog: MatDialog,
    private bottomDialog: MatBottomSheet,
    private titleService: Title,
    private messageService: MessageService,
    private router: Router,
    private routerActivate: ActivatedRoute,
    private browserService: BrowserStorageService,
    private metaTagService: Meta,
    @Inject(DOCUMENT) private document: Document) {
    this.filterOptionList = FILTER_JSON;
    this.isMobileDisableClick = this.checkMobileDevice();
    this.createUrlParametersList();
    this.beatService.getSearchFilter().subscribe( (searchList: Array<SearchFilterModel>) => {
      this.selectedSearchType = searchList[0];
      this.searchFilterType = searchList;
    });
    this.refreshSearchPlaceholder();
    let viewType: any = this.browserService.getViewType();
    if (!viewType) {
      this.browserService.setBeatViewType('list');
    } else {
      this.beatView.next(viewType);
    }
  }

  createUrlParametersList() {
    this.urlKeysList = URL_PARAMETERS;
  }

  refreshSearchPlaceholder(searchType: SearchFilterModel = this.selectedSearchType): void {
    const selectedValue = searchType?.value;
    if (!selectedValue || selectedValue === 'general') {
      this.startSearchPlaceholderCycle();
      return;
    }

    this.stopSearchPlaceholderCycle();
    this.searchPlaceholderText = this.normalizeSearchPlaceholderLabel(searchType?.label);
  }

  private startSearchPlaceholderCycle(): void {
    this.stopSearchPlaceholderCycle();
    this.searchPlaceholderIndex = 0;
    this.searchPlaceholderText = '';
    this.playSearchPlaceholderSequence();
  }

  private stopSearchPlaceholderCycle(): void {
    this.searchPlaceholderTimers.forEach(timerId => window.clearTimeout(timerId));
    this.searchPlaceholderTimers = [];
  }

  private playSearchPlaceholderSequence(): void {
    const text = this.generalSearchPlaceholders[this.searchPlaceholderIndex];
    const typingDelay = 70;
    const deletingDelay = 45;
    const holdDelay = 1200;

    const scheduleTimer = (callback: () => void, delay: number): void => {
      const timerId = window.setTimeout(() => {
        this.searchPlaceholderTimers = this.searchPlaceholderTimers.filter(activeTimerId => activeTimerId !== timerId);
        callback();
      }, delay);

      this.searchPlaceholderTimers.push(timerId);
    };

    const typeText = (position: number): void => {
      this.searchPlaceholderText = text.slice(0, position);

      if (position < text.length) {
        scheduleTimer(() => typeText(position + 1), typingDelay);
        return;
      }

      scheduleTimer(() => deleteText(text.length), holdDelay);
    };

    const deleteText = (position: number): void => {
      this.searchPlaceholderText = text.slice(0, position);

      if (position > 0) {
        scheduleTimer(() => deleteText(position - 1), deletingDelay);
        return;
      }

      this.searchPlaceholderIndex = (this.searchPlaceholderIndex + 1) % this.generalSearchPlaceholders.length;
      scheduleTimer(() => this.playSearchPlaceholderSequence(), 250);
    };

    typeText(1);
  }

  private normalizeSearchPlaceholderLabel(label?: string): string {
    if (!label) {
      return 'beats';
    }

    const normalized = label.trim().toLowerCase();
    if (!normalized) {
      return 'beats';
    }

    if (normalized === 'beat' || normalized === 'beats' || normalized === 'sound' || normalized === 'sounds') {
      return 'title';
    }

    return normalized.endsWith('s') ? normalized.slice(0, -1): normalized;
  }

  upDateOnWindowResize(event: any) {
    this.isMobileDisableClick = this.checkMobileDevice();
    if (event.target.innerWidth > 991) {
      this.isMobileDisableClick = false;
      // desktop now: bottom sheets (mobile popups) are closed
      this.closeOpenPopups(ref => !this.isDialogRef(ref));
    } else if (event.target.innerWidth < 767) {
      this.isMobileDisableClick = true;
      // mobile now: dialogs (desktop popups) are closed
      this.closeOpenPopups(ref => this.isDialogRef(ref));
    }
  }

  // ==================== Popups ====================
  // Every open popup is kept in a stack (last = top, the one the user sees).
  // - closePopUp() / closingPopupWithSendData() close the top popup, so with two or more
  //   popups open each close button closes its own popup and the one below stays closable.
  // - modelRef / bottomRef always point to an open popup: when the popup they point to
  //   closes, they move to the popup below (components subscribe to them after openModel()).

  /** Open popups, oldest first. */
  private openPopups: Array<MatDialogRef<any> | MatBottomSheetRef<any>> = [];

  openModel(
    template: any,
    sendData: any,
    className: any,
    disableClose: boolean = false,
    isShowTwoPopup: boolean = false) {
    this.isShowTwoPopupSameTime = isShowTwoPopup;
    this.isMobileDisableClick
      ? this.openMobileDialog(template, sendData, className, disableClose)
      : this.openDesktopDialog(template, sendData, className, disableClose);
  }

  openDesktopDialog(
    template: any,
    sendData: any,
    className: any,
    disableClose: boolean = false) {
    let  classNameList: Array<string> = ['ipm-custom-mat-dialog'];
    classNameList.push(className);
    let modelRefTemp = this.matDialog.open(template, {
      panelClass: classNameList,
      data: sendData,
      autoFocus: false,
      disableClose: disableClose,
    });
    if (this.isShowTwoPopupSameTime) {
      this.modelRefSecond = modelRefTemp;
    } else {
      this.modelRef = modelRefTemp;
    }
    this.trackPopup(modelRefTemp);
  }

  openMobileDialog(
    template: any,
    sendData: any,
    className: any,
    disableClose: boolean = false
  ) {
    let  classNameList: Array<string> = ['ipm-custom-mat-dialog'];
    classNameList.push(className);
    let bottomRefTemp = this.bottomDialog.open(template, {
      panelClass: classNameList,
      data: sendData,
      autoFocus: false,
      disableClose: disableClose,
    });
    if (this.isShowTwoPopupSameTime) {
      this.bottomRefSecond = bottomRefTemp;
    } else {
      this.bottomRef = bottomRefTemp;
    }
    this.trackPopup(bottomRefTemp);
  }

  private isDialogRef(ref: MatDialogRef<any> | MatBottomSheetRef<any>): ref is MatDialogRef<any> {
    return typeof (ref as MatDialogRef<any>).close === 'function';
  }

  private trackPopup(ref: MatDialogRef<any> | MatBottomSheetRef<any>) {
    this.openPopups.push(ref);
    const closed$ = this.isDialogRef(ref) ? ref.afterClosed() : ref.afterDismissed();
    closed$.subscribe(() => this.onPopupClosed(ref));
  }

  /** A popup closed (button, backdrop, Esc, route change...): point the refs at what is still open. */
  private onPopupClosed(closedRef: MatDialogRef<any> | MatBottomSheetRef<any>) {
    this.openPopups = this.openPopups.filter(ref => ref !== closedRef);
    const topDialog = [...this.openPopups].reverse().find(ref => this.isDialogRef(ref)) as MatDialogRef<any>;
    const topSheet = [...this.openPopups].reverse().find(ref => !this.isDialogRef(ref)) as MatBottomSheetRef<any>;
    if (this.modelRefSecond === closedRef) {
      this.modelRefSecond = null as any;
    }
    if (this.bottomRefSecond === closedRef) {
      this.bottomRefSecond = null as any;
    }
    if (this.modelRef === closedRef) {
      this.modelRef = topDialog;
    }
    if (this.bottomRef === closedRef) {
      this.bottomRef = topSheet;
    }
    this.isShowTwoPopupSameTime = !!(this.modelRefSecond || this.bottomRefSecond);
  }

  private closeRef(ref: MatDialogRef<any> | MatBottomSheetRef<any>, data: any) {
    // leave the stack right away, so a second close call in the same tick closes the next popup
    this.openPopups = this.openPopups.filter(item => item !== ref);
    this.isDialogRef(ref) ? ref.close(data) : ref.dismiss(data);
  }

  private closeOpenPopups(predicate: (ref: MatDialogRef<any> | MatBottomSheetRef<any>) => boolean) {
    [...this.openPopups].reverse().filter(predicate).forEach(ref => this.closeRef(ref, ''));
  }

  /** Closes the top popup (the one on screen). */
  private closeTopPopup(data: any = '') {
    const top = this.openPopups[this.openPopups.length - 1];
    if (top) {
      this.closeRef(top, data);
    } else {
      // popup opened outside openModel(): fall back to the stored refs
      this.firstModelClose(data);
    }
  }

  closePopUp() {
    this.closeTopPopup();
  }

  secondModelClose(data: any = '') {
    if (this.modelRefSecond) {
      this.closeRef(this.modelRefSecond, data);
    }
    if (this.bottomRefSecond) {
      this.closeRef(this.bottomRefSecond, data);
    }
  }

  firstModelClose(data: any = '') {
    if (this.modelRef) {
      this.closeRef(this.modelRef, data);
    }
    if (this.bottomRef) {
      this.closeRef(this.bottomRef, data);
    }
  }

  closingPopupWithSendData(sendType: any) {
    this.closeTopPopup(sendType);
  }

  backdropClickSendFunction(sendType: any) {
    // capture the popup now: by the time the backdrop is clicked modelRef may point to another popup
    if (!this.isMobileDisableClick) {
      const dialogRef = this.modelRef;
      dialogRef?.backdropClick().subscribe(() => this.closeRef(dialogRef, sendType));
    } else {
      const sheetRef = this.bottomRef;
      sheetRef?.backdropClick().subscribe(() => this.closeRef(sheetRef, sendType));
    }
  }

  getClassName(className: string) {
    let newClassName = '';
    if (this.isMobileDisableClick) {
      newClassName = 'mobile-' + className;
      return newClassName;
    } else {
      return className;
    }
  }

  checkMobileDevice() {
    let isMobile = false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
    }

    return isMobile;
  }

  setTitleService(titleName:string, description: string = "") {
      let staticDesc = "India's Largest Beats Marketplace | Retain 100% Earnings | License with unlimited usage | Free MP3 downloads | Upto 99 years lease | Digital Contracts";
      let currentBrand: string = "beat22";
      let  newTitle = titleName+" | "+currentBrand;
      let desc : any =  description ? description : staticDesc;
      this.titleService.setTitle(newTitle);
      this.metaTagService.updateTag({ property: 'title', content: newTitle });
      this.metaTagService.updateTag({ property: 'description', content: desc });
      this.metaTagService.updateTag({ property: 'og:title', content: newTitle });
      this.metaTagService.updateTag({ property: 'og:description', content: desc });
      this.updateConicalMetaTags();
  }

  updateConicalMetaTags() {
    this.metaTagService.updateTag({ property: 'og:url', content: location.href });
    this.setCanonicalURL(location.href);
  }


  setCanonicalURL(url?: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    let link = this.document.querySelector("link[rel='canonical']");

    if (link) {
      // If it exists, update it
      link.setAttribute('href', url || this.document.URL);
    } else {
      // Otherwise, create it
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url || this.document.URL);
      head.appendChild(link);
    }
  }

  showToastSuccess(messages: string) {
    this.messageService.add({ severity: 'success', summary: '', detail: messages });
  }
  showToastError( err: any) {
    let message = 'Something is wrong';
    if (err?.error?.message) {
      message = err.error.message;
    } else if (err?.error?.details) {
      message = err?.error?.details;
    } else if (err?.error?.error) {
       message = err?.error?.error;
    }
    this.showToastErrorMessage(message);
  }

  showToastErrorMessage(message: string) {
    this.messageService.add({ severity: 'error', summary: '', detail: message });
  }

  dashBoardRedirect(reDirectType: any = '') {
    const previousRoute = this.browserService.getPreviousRoute();
    if (previousRoute && !this.browserService.isBaseRoute(previousRoute)) {
      // If there's a previous route and it's not a base route, redirect there
      this.browserService.clearPreviousRoute();
      this.router.navigate([previousRoute]).then(() => {
        // Small delay to ensure navigation completes before reload
        setTimeout(() => {
          location.reload();
        }, 100);
      });;
    } else {
      // Otherwise, redirect to appropriate dashboard based on user role
      const userRole = this.browserService.getCurrentRoles();
      const dashboardRoute = this.browserService.getDashboardRoute(userRole);
      this.router.navigate([dashboardRoute]).then(() => {
        // Small delay to ensure navigation completes before reload
        setTimeout(() => {
          location.reload();
        }, 100);
      });;
    }
  
    // Reload to ensure proper state
    location.reload();
  }

  /**
   * Redirect to previous route or dashboard after authentication
   * @param userRole - user role to determine dashboard
   */
  redirectAfterAuth(userRole?: string) {
    const role = userRole || this.browserService.getCurrentRoles();
    const previousRoute = this.browserService.getPreviousRoute();
    if (previousRoute && !this.browserService.isBaseRoute(previousRoute)) {
      // Redirect to previous route if it exists and is not a base route
      this.browserService.clearPreviousRoute();
      this.router.navigate([previousRoute]).then(() => {
        // Small delay to ensure navigation completes before reload
        setTimeout(() => {
          location.reload();
        }, 100);
      });;
    } else {
      // Redirect to appropriate dashboard
      const dashboardRoute = this.browserService.getDashboardRoute(role);
      this.router.navigate([dashboardRoute]).then(() => {
        // Small delay to ensure navigation completes before reload
        setTimeout(() => {
          location.reload();
        }, 100);
      });;
    }
  }

  /**
   * Open Seller agreement dialog Box
   * common Function
   * @param template template
   * @param isShowAgree boolean this option params
   * @param isOpenTwoPopup  boolean this also optional params
   */
  openCommonSellerPop(template: any, isShowAgree: boolean = false, isOpenTwoPopup: boolean = false) {
    let data: any = {
      isShow: isShowAgree,
    };
    let className = this.isMobileDisableClick
      ? 'mobile-ipm-view-seller-model'
      : 'ipm-seller-model';
    this.openModel(template, data, className, true, isOpenTwoPopup);
  }

  /**
   * Get Country List From Asset
   * @returns
   */
  getCountriesList(): Array<CountriesListModel> {
    return COUNTRIES_LIST;
  }

  /**
   * get Age List from assets
   * @returns
   */
  getAgeList(): Array<any> {
    return AGE_LIST;
  }

  /**
   * Open Support  In this function
   * Redirect to whatsapp
   */
  openSupport(type: string = "") {
    const link = document.createElement('a');
    let href = 'https://wa.me/919872066692';
    if (type) {
      href = "mailto:support@beat22.com";
    }
    link.setAttribute('target', '_blank');
    link.setAttribute('href', href);
    link.click();
  }

  /**
   * Open License Blog
   * Redirects to the beat22 blog article about exclusive vs non-exclusive licensing
   */
  openLicenseBlog() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', 'https://blog.beat22.com/exclusive-vs-non-exclusive-licensing-which-one-should-you-choose/');
    link.click();
  }

   /**
   * Open auth Popups
   * @param loginType
   * @param deviceType
   */
   authModel( loginType: string, loginSignupTemplate: any, deviceType = 'desktop', clickType = '',isDisabledClose: boolean = false) {
    if (deviceType === 'mobile') {
      if (this.bottomRef) {
        this.bottomRef.dismiss();
      }
    }
    const dataSend = {
      type: loginType,
      openType: clickType,
    };
    let className = this.isMobileDisableClick ? 'mobile-view-auth-model' : 'auth-model';
    this.openModel(loginSignupTemplate, dataSend, className, isDisabledClose);
  }

  /**
   * Go to artist profile page
   * @param profileHandle
   */
  goToArtistProfile(profileHandle: string) {
    this.router.navigate([`/${profileHandle}`]);
  }

  /**
   * In this Function We are calling Download function
   * and passing download url to download function
   * @param url
   * @param type
   * @param fileName
   */
  downloadFile(url: any, type: any,fileName?:any) {
    if (url) {
      this.downloadData(url, type,fileName);
    }
  }

  /**
   * Download Data function
   * @param url
   */
  downloadData(url: any, typeFile?: string, mp3Object?:any, fileName?:any) {
    if (url) {
      const imgUrl = url;
      const imgName = imgUrl.substr(imgUrl.lastIndexOf('/') + 1);
      // this.httpClient
      //   .get(imgUrl, { responseType: 'blob' as 'json' })
      //   .subscribe((res: any) => {
      //     const file: any = new Blob([res], { type: typeFile ===  "audio"?  'audio/mp3' :  res.type });
      //     const nav = window.navigator as any;
      //     if (nav && nav.msSaveOrOpenBlob) {
      //       nav.msSaveOrOpenBlob(file);
      //       return;
      //     }
      //     const blob = this.dom.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));
      //     const link = document.createElement('a');
      //     link.href = window.URL.createObjectURL(file);
      //     link.download = fileName ? this.createFileName(fileName, typeFile) : imgName;
      //     link.setAttribute('target', '_blank');
      //     link.click()  //to work at firefox
      //     try {
      //       link.dispatchEvent(
      //         new MouseEvent('click', {
      //           bubbles: true,
      //           cancelable: true,
      //           view: window,
      //         })
      //       );
      //       setTimeout(() => {
      //         window.URL.revokeObjectURL(file);
      //         link.remove();
      //       }, 100);
      //       if ( typeFile ===  "audio") {
      //         if (mp3Object) {
      //           mp3Object.count += 1;
      //         } else {
      //           mp3Object = {
      //             count: 1,
      //             month:moment().format('yyyy-MM').toString()
      //           }
      //         }
      //         this.storageService.updateDownloadLimit(mp3Object);
      //       }
      //     } catch(error) {

      //     }

      //   });
        try {
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName ? this.createFileName(fileName, typeFile) : imgName;
          link.setAttribute('target', '_blank');

          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
          if (isIOS && isSafari) {
            setTimeout(function() {
              link.click();
              // Cleanup the DOM
              document.body.removeChild(link);
            }, 500);
          } else {
            link.click();
            document.body.removeChild(link);
          }

        } catch(error: any) {
        }
    }
  }

  /**
   * create file download file name
   * @param beatData
   * @param type
   * @returns
   */
  createFileName(beatData: any, type: any) {
    let beatName =  beatData?.title;
    if (type === 'audio') {
      let storeName = beatData?.producer?.store?.general?.name;
        if (beatName &&  storeName) {
          return beatName.replace(" ","_").toLowerCase() + "_" +  storeName.replace(" ","_").toLowerCase();
      }
    } else {
        if (beatName) {
          return beatName.replace(" ","_").toLowerCase() + "_" +type;
        }
    }
    return '';
  }
  /**
   * In this function we are formatting a number
   * just like this 2k , %.5m
   * @param num  : number
   * @param digits : number
   * @param rupeeSymbols : string
   * @returns
   */
  nFormatter(num: any, digits: any, rupeeSymbols: string = '') {
    let finalValue: any = '';
    if (num !== '' && num !== undefined && num !== null) {
      const lookup = [
        { value: 1, symbol: '' },
        { value: 1e3, symbol: 'K' },
        { value: 1e6, symbol: 'M' },
        { value: 1e9, symbol: 'G' },
        { value: 1e12, symbol: 'T' },
        { value: 1e15, symbol: 'P' },
        { value: 1e18, symbol: 'E' },
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var item = lookup
        .slice()
        .reverse()
        .find(function (item) {
          return num >= item.value;
        });
      finalValue = item
        ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
        : '0';
      if (rupeeSymbols) {
        finalValue = rupeeSymbols + finalValue;
      }
      return finalValue;
    }

    return finalValue;
  }

  /**
   * In this function we are sending the parameters in to url
   * @param searchValue : string
   * @param type : string filter/search
   */
  sendSearchDataUrl(searchValue: string, type: string, componentType: string = "") {
    this.routerActivate.queryParams.subscribe((params:Params) => {
      let paramsObj: any = Object.assign({}, params);
      if (type === 'search') {
        if (Object.keys(paramsObj).length > 0 && !paramsObj['sV']) {
          paramsObj = this.resetFilterOption(paramsObj);
        }
        paramsObj = this.createUrlParamsForSearch(searchValue, paramsObj);
      } else {
        paramsObj = this.createUrlParamsForFilter(this.filterOptionList, paramsObj);
      }
      this.sendParamsInUrlFunc(paramsObj, type, componentType);
    }).unsubscribe();
  }


  sendParamsInUrlFunc(paramsObj: Object, type: string, componentType: any = "") {
    if (componentType) {
      if ( Object.keys(paramsObj).length > 0) {
          this.router.navigate([], { relativeTo: this.routerActivate ,queryParams: paramsObj});
      } else {
        this.router.navigate([]);
      }
    } else {
      let routesList = ['/latestbeats'];
      if ( Object.keys(paramsObj).length > 0) {
        if (!routesList.includes(this.router.url.split("?")[0])) {
          this.router.navigate(['/latestbeats'], { relativeTo: this.routerActivate ,queryParams: paramsObj});
        } else {
          this.router.navigate([], { relativeTo: this.routerActivate ,queryParams: paramsObj});
        }
      } else {
        this.router.navigate([]);
      }
    }
  }

  /**
   * add and remove params for search
   * @param value
   * @param params
   * @returns
   */
  createUrlParamsForSearch(value: string, params: any) {
    if (!value) {
      if (params.hasOwnProperty('sV')) {
        delete params['sV'];
        delete params['sK'];
      }
    } else {
      if (value.trim()) {
        params['sV'] = value;
        params['sK'] = this.selectedSearchType.value;
      }
    }
    return params;
  }

  /**
   * in this function prepare params for url according to the selected
   * @param filterObjectList
   * @param params
   * @returns
   */
  createUrlParamsForFilter(filterObjectList: Array<FilterListModel>, params: any) {
    filterObjectList.map((filterObj: FilterListModel) => {
      if (filterObj.filter_type === 'multiselect') {
        if (filterObj.filter_selected_values.length > 0) {
          params[filterObj.urlLabelName] = this.createFilterParamsKeyValues(filterObj.filter_selected_values);
        } else {
          if(params.hasOwnProperty(filterObj.urlLabelName)) {
            delete params[filterObj.urlLabelName];
          }
        }
      } else if (filterObj.filter_type === 'menu') {
        if (filterObj.ApiFilterKey === 'price') {
          if (filterObj.selectedPriceType && filterObj.selectedPriceType !== 'wav') {
            params['pt'] = filterObj.selectedPriceType;
          } else if (params.hasOwnProperty('pt')) {
            delete params['pt'];
          }
        }
        let endRange = filterObj.filter_sub_list[0].end_range.trim();
        let startRange = filterObj.filter_sub_list[0].starting_range.trim();
        let defaultStartRange =  +filterObj.filter_selected_values[0].starting_range;
        let defaultEndRange =  +filterObj.filter_selected_values[0].end_range;
        if (endRange &&  startRange) {
          if (defaultStartRange !==  parseInt(startRange) || defaultEndRange !== parseInt(endRange)) {
            filterObj.filter_selected_values[0].starting_range = startRange;
            filterObj.filter_selected_values[0].end_range = defaultEndRange;
            if ((parseInt(endRange) < parseInt(startRange))) {
              endRange =  parseInt(startRange) < 11 ?  "11" : startRange
            }
            params[filterObj.urlLabelName] = startRange+"-"+endRange;
            filterObj.isFilterApplied = true;
          } else {
            if (defaultStartRange === 0 &&  parseInt(startRange) === 0) {
              if(params.hasOwnProperty(filterObj.urlLabelName)) {
                  delete params[filterObj.urlLabelName];
                }
                filterObj.isFilterApplied = false;
            }
          }
        }
      } else if (filterObj.filter_type === 'swipes-menu') {
        filterObj.filter_sub_list.map((sliderFilter: FilterSubsListObj) => {
          if (sliderFilter.urlLabelName) {
            if (sliderFilter.isSelected &&  sliderFilter.urlLabelName !== "tb") {
              params[sliderFilter.urlLabelName] =  sliderFilter.isSelected
            } else {
              if(params.hasOwnProperty(sliderFilter.urlLabelName)) {
                delete params[sliderFilter.urlLabelName];
              }
            }
          }
        })
        // params =  {...params, ...this.createFilterParamsForSwiper(filterObj, params)}
      } else if (filterObj.filter_type === 'swipes-menu-bpm-offer') { 
        let found: any = filterObj.filter_sub_list.find((sliderFilter: FilterSubsListObj) => sliderFilter.isSelected === true);
        if (found) {
           params[found.urlLabelName] =  found.key;
        } else {
          if(params.hasOwnProperty("bpmOffer")) {
            delete params["bpmOffer"];
          }
        }
      } else {
        if (filterObj.filter_selected_values.length > 0) {
          const sortKey = filterObj.filter_selected_values[0].key ?? '';
          const sortIdMap: Record<string, string> = {
            price_desc: '1', price_asc: '2', one_scroll_algo: '3', recent_beats: '4'
          };
          let sendData: any = {
            name:filterObj.filter_selected_values[0].value,
            id: sortIdMap[sortKey] ?? '3',
            key: sortKey
          }
          this.sortFilter.next(sendData);
        }
      }
    });
    return params;
  }

  /**
   * in this function preparing value
   * that we have to send in url just like this  abs,cdf,mac
   * @param selectedFilter
   * @returns
   */
  createFilterParamsKeyValues(selectedFilter: Array<FilterSubsListObj>): string {
    let finalParamsValue = "";
    selectedFilter.map((item: FilterSubsListObj, index: number) => {
      finalParamsValue += item.key;
      if ((selectedFilter.length - 1) > index) {
        finalParamsValue += ",";
      }
    })
    return finalParamsValue;
  }

  /**
   * set Value in value in search dropdown
   * @param value string
   */
  setSearchDropdown(value: string) {
    if (value) {
      let foundObj: any = this.searchFilterType.find((item: any) =>  item.value === value);
      this.selectedSearchType = foundObj;
    }
  }

  /**
   * In this function reset all
   * the filter that current applied
   */
  resetFilter() {
    this.selectedSearchType = { label: 'General', value: 'general', apiKeys: [
    "sounds",
    "title",
    "tag",
    "mood",
    "genre",
    "profile_handle",
    "name"
  ]}
    this.selectedSearchInputValue = "";
    this.resetFilterOption();
  }

  /**
   * In this function reset the value of filter
   * and remove the parameters fro url according to
   * this parameter if this parameter contains some value then
   * remove parameter from url
   * @param params
   * @returns
   */
  resetFilterOption(params: any = "") {
    this.filterOptionList.filter((item: FilterListModel) => {
      if (item.filter_type === "multiselect") {
        item.filter_selected_values = [];
      } else if (item.filter_type === "menu") {
        item.filter_sub_list[0].end_range =  item.ApiFilterKey === "tempo" ? "500" : "100000";
        item.filter_sub_list[0].starting_range = "0";
        item.filter_selected_values[0].starting_range = item.filter_sub_list[0].starting_range;
        item.filter_selected_values[0].end_range =  item.filter_sub_list[0].end_range;
      } else {
        item.filter_sub_list.map( swiperObj => {
          swiperObj.isSelected = false;
        })
      }
      if (params) {
        if (params[item.urlLabelName]) {
          delete params[item.urlLabelName];
        }
      }
    });
    return  params ?  params : '';
  }

  /**
   * price type (mp3/wav/stem/exclusive) currently selected on the Price range
   * filter — reused by price-based sort so both features stay in sync.
   */
  getSelectedPriceType(): string {
    const priceFilter = this.filterOptionList.find((item: FilterListModel) => item.ApiFilterKey === 'price');
    return priceFilter?.selectedPriceType || 'wav';
  }

  /**
   * In this function update filter object for send  in api params
   * according to data present into url
   * @param params
   * @returns
   */
  setFilterValuesForBeats(params: any) {
    let filterObject: any = {};
    if (params['sV']) {
      let keyList: Array<string> = this.selectedSearchType.apiKeys;
      filterObject.search = {
        keys: keyList,
        values: [this.selectedSearchInputValue]
      }
    }
    filterObject.filter = {};
    this.filterOptionList.map((filObj: FilterListModel) => {
      let filterKey: any = filObj?.ApiFilterKey
      if (filObj.filter_type === "multiselect") {
        if (filObj.filter_selected_values.length > 0) {
          let valuesList: Array<string> = [];
          let selectedValue: Array<FilterSubsListObj> =  filObj.filter_selected_values;
          selectedValue.map((item: FilterSubsListObj, index: number) => {
              let keyValue = selectedValue.length > 1 && (selectedValue.length - 1)  > index? item.key :  item.key;
              if (keyValue) {
                valuesList.push(keyValue)
              }
          });
          if (valuesList.length > 0) {
            let  object: any = {};
            object[filterKey] = valuesList;
            filterObject.filter = {...filterObject.filter, ...object};
          }
        }
      } else if (filObj.filter_type === "menu") {
        if (params[filObj.urlLabelName]) {
          let startRange = filObj.filter_sub_list[0].starting_range;
          let endRange = filObj.filter_sub_list[0].end_range;
          if ((startRange && endRange)) {
            let valuesList: any = {};
            let  object: any = {};
            valuesList['min'] = parseInt(startRange);
            valuesList['max'] =  parseInt(endRange);
            if (filterKey === 'price') {
              valuesList['type'] = params['pt'] || filObj.selectedPriceType || 'wav';
            }
            object[filterKey] = valuesList;
            filterObject.filter = {...filterObject.filter, ...object};
          }
        }
      } else {
        let filterSubList: Array<FilterSubsListObj> =  filObj.filter_sub_list;
        let object: any = {};
        filterSubList.map((item: FilterSubsListObj) => {
          if (item?.ApiFilterKey &&  item.isSelected) {
            object[item?.ApiFilterKey] = filObj.filter_type === "swipes-menu-bpm-offer" ? parseInt(item.key ? item.key : "30") : item.isSelected;
          }
        });
        if (Object.keys(object).length > 0) {
          filterObject.filter = {...filterObject.filter, ...object}
        }
      }
    });
    return filterObject;
  }

  isCheckCurrentUrlMatch(currentUrl: string): boolean {
    let url: Array<string> =  this.router.url.split('/');
    return url.includes(currentUrl);
  }

  /**
   * check producer fill setting data or not
   * @returns
   */
  checkProducerFillData(userObject: UserDetails): boolean {
    let isProfileComplete: boolean = false;
      if (userObject && Object.keys(userObject).length > 0 && userObject?.role === "producer") {
          let storeData: StoreObj = userObject.detail.store;
          if (userObject.hasOwnProperty('mobile') && userObject.mobile.isVerified) {
            if ((userObject.hasOwnProperty('aadhaarVerification') && (userObject?.aadhaarVerification?.verified && !userObject.aadhaarVerification?.guardianRequired) || 
            (userObject.aadhaarVerification?.guardianRequired && userObject.aadhaarVerification.verified && userObject.aadhaarVerification?.guardianVerified)) || 
                (userObject.hasOwnProperty('passportValidation') && userObject.passportValidation.verified)) {
              if (storeData && Object.keys(storeData).length > 0) {
                let generalSetting = storeData?.general;
                let profileHandle  = userObject.handle;
                let payment = storeData?.payment;
                // let brand = storeData?.brand;
                if ((generalSetting &&  Object.keys(generalSetting).length > 0) &&
                    (payment && Object.keys(payment).length > 0) &&
                    profileHandle) {
                      this.billingAddressEvent.subscribe((billingAddressList: Array<BillingListModel>) => {
                        isProfileComplete = billingAddressList.length > 0 ? true : false;
                      })
                }
              }
            }
          }
      }
    return isProfileComplete;
  }

  /**
   * Check if user has completed Aadhaar or passport identity verification.
   * Returns true when verification is complete, false otherwise.
   * @param user UserDetails object
   * @returns boolean
   */
  isAadhaarVerified(user: UserDetails): boolean {
    if (!user) return false;
    const av = user.aadhaarVerification;
    if (av?.verified) {
      if (av.guardianRequired) {
        return !!av.guardianVerified;
      }
      return true;
    }
    const pv = (user as any).passportValidation;
    return !!(pv?.verified);
  }

  createFilterParamsForSwiper(filterValue: FilterListModel, params: any ) {
    // filterValue.map( (items:FilterSubsListObj) => {
    //   if (items.) {

    //   }
    // })

  }

  isShowConfirmationsDialogBox() {
    let currentUrl = window.location.pathname;
    if (currentUrl.startsWith('/upload/beat') || currentUrl.startsWith('/upload/sound')) {
      return true;
    } else {
      return false;
    }
  }

  applyGenreFilters(filterKeyName: string, keyName: string = "") {
    this.filterOptionList =  this.filterOptionList.filter((filterObj: FilterListModel) => {
      if (filterObj.ApiFilterKey ===  "genres") {
          let foundObj: any =  filterObj.filter_sub_list.find((filterSubMenuObj: any) => filterSubMenuObj[keyName] ===  filterKeyName);
          if (foundObj) {
            if (filterObj.filter_selected_values.length === 0) {
              filterObj.filter_selected_values.push(foundObj);
            } else {
              let SelectedMenuFound: any =  filterObj.filter_selected_values.find((SelectSubMenuObj: any) => SelectSubMenuObj[keyName] === filterKeyName);
              if (!SelectedMenuFound) {
                filterObj.filter_selected_values.push(foundObj);
              }
            }
          }
        }
      return filterObj
    });
    this.sendSearchDataUrl("", 'filter');
  }

  makeId(length: any) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  /**
   * Error Handler
   * @param event
   */
  errorHandler(event: any) {
    let imageName = 'icons/music-Icon.svg';
    event.target.src = environment.imageUrl+imageName;
  }

  calculateAge(dob: any) {
    if (!dob) return;
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  saleDataUpdate(platFormData: any) {
    const platFormDataTemp: any = platFormData && Object.keys(platFormData).length > 0 ? platFormData : [];
    const activeSale = this.getActivePlatformSale(platFormDataTemp);
    this.enrollmentActive = this.isEnrollmentActive(activeSale);
    this.saleActive = this.isSaleActive(activeSale);
    this.browserService.setEnrollmentActiveFlag(this.enrollmentActive);
    this.browserService.setSaleActiveFlag(this.saleActive);
    this.platformSaleData.next(platFormDataTemp);
  }

  // ==================== Platform sale (platformSaleData API) ====================

  /** The active platform sale (is_active), if any */
  getActivePlatformSale(saleList: any = this.platformSaleData.value): any {
    return Array.isArray(saleList) ? saleList.find((sale: any) => sale?.is_active === true) || null : null;
  }

  /** Enrollment active: the sale is active (is_active) and the current date is between enrollment_opens_at and end_at */
  isEnrollmentActive(sale: any = this.getActivePlatformSale(), now: number = Date.now()): boolean {
    return !!sale?.is_active
      && (!sale.enrollment_opens_at || now >= new Date(sale.enrollment_opens_at).getTime())
      && (!sale.end_at || now <= new Date(sale.end_at).getTime());
  }

  /** Sale active: the sale is active (is_active) and the current date is between start_at and end_at */
  isSaleActive(sale: any = this.getActivePlatformSale(), now: number = Date.now()): boolean {
    return !!sale?.is_active
      && (!sale.start_at || now >= new Date(sale.start_at).getTime())
      && (!sale.end_at || now <= new Date(sale.end_at).getTime());
  }

  /** Beat shown as on sale (discount badge, sale price, struck-through price) only once the sale has started:
   *  sale_info.is_on_sale is already true when the producer enrols the beat, before start_at */
  isBeatOnSale(beat: any): boolean {
    return !!beat?.sale_info?.is_on_sale && this.isSaleActive();
  }

  /**
   * Mirror the beat player's playing flag onto a shared BehaviorSubject so
   * other components (e.g. MagicSearch) can react without creating a
   * circular dependency on PlayerService.
   * @param isPlaying
   */
  setMusicPlaying(isPlaying: boolean): void {
    if (this.isMusicPlaying$.value !== isPlaying) {
      this.isMusicPlaying$.next(isPlaying);
    }
  }

  /**
   * Mirror MagicSearch's speech-recognition active flag onto a shared
   * BehaviorSubject so MusicPlayer can stop the mic session when the user
   * starts a beat, without taking a direct dependency on MagicSearch.
   * @param isListening
   */
  setSpeechListening(isListening: boolean): void {
    if (this.isSpeechListening$.value !== isListening) {
      this.isSpeechListening$.next(isListening);
    }
  }

  /**
   * Downloads a blob using the File system access API(showSaveFilePicker)
   * so the user can choose the save location. Falls back to a standard
   * <a> tag download (default downloads folder) on unsupported browsers 
   * (Firefox, safari , older Edge).
   * 
   * @param blob  The raw binary data to save 
   * @param filename Suggested file name including extension (e.g. "my-beat.mp3")
   */
  async downloadBlob(blob: Blob, filename: string): Promise<void> {
    // Force octet-stream so the browser treats it as an opaque download
    // and does not navigate to or open the blob URL (e.g. audio player).
    // showSaveFilePicker is intentionally skipped here because it requires
    // a synchronous user gesture and is always blocked inside HTTP callbacks.
    const forceDownloadBlob = new Blob([blob], { type: 'application/octet-stream' });
    const objectUrl = window.URL.createObjectURL(forceDownloadBlob);
    const link = this.document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    this.document.body.appendChild(link);
    link.click();
    this.document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 100);
  }
  /** Returns true while the July 2026 cashback offer is still active (up to July 31 2026 23:59:59 IST). */
  isJulyOfferActive(): boolean {
    return Date.now() < new Date('2026-08-01T00:00:00.000+05:30').getTime();
  }
}
